import React, { Component, Fragment } from "react";
import { NavLink } from "react-router-dom";
import Header from "../account/Header";
import AccountNav from "../account/AccountNav";
import AppContext from "../../../contexts/AppContext";
import CreditModal from "../credits/CreditModal";
import { credits } from "../../../services/billing";
import LoadingData from "../../utilities/LoadingData";
import CreditHistory from "./CreditHistory";

class Credits extends Component {
    state = {
        items: [],
        meta: {},
        query: "",
        loading: true,
        creditList: [],
        createM : false,
        curCredit : 0,
        showHistory : false
    };

    toggleCreate = () => {
        this.setState({ createM: this.state.createM === true ? false : true });
    };

    componentDidMount() {   
        this.setState({ showHistory: false });
        this.getData();
	}

    getData(){
        this.setState({                  
            loading: true,
        });
        setTimeout(() => {
            credits()
            .then(response => {                
                var plandata = [];
                if(response.meta)
                {                   
                    Object.entries(response.meta).map(([key, plans]) => {
                        var d = {"id":plans.id,"value":plans.id,"name":plans.description,"label":plans.description , "price": plans.price,"balance":plans.balance};
                        plandata.push(d);
                    })
                }
    
                this.setState({                   
                    curCredit: response.data.balance,                                     
                    loading: false,
                    creditList: plandata
                });
                //console.log(this.state.item)
            })
            .catch(error => {
                this.context.state.handelError(error);
                this.setState({                  
                    loading: false,
                });
            });
        }, 1000)
    }  
    
    setCredit = () =>
    {
        this.getData();
    }
    
    creditHistory = () =>
    {
        this.setState({ showHistory: this.state.showHistory === true ? false : true });        
    }

    render() {
        return (
            <Fragment>
                        <Header></Header>
                <div>
				    {/* <section className="dashboard-nav">
		                <div className="container">
		            	    <div className="head">
		            		    <h1>Settings</h1>
		            		</div>		            		
		            		<AccountNav></AccountNav>
		            	</div>
		            </section> */}
					<section className="settingsDetails_v2 pt-md-15 pb-md-40 pb-20 pt-20 mt-4">
						<div className="container writer-container">
							<div className="row">
								<div className="col-md-3">
							        <div className="card custom">
							            <div className="card-header">
							        	    Settings
							            </div>
                                        <div className="card-body">									
							        	    <nav className="custom-sidenav" id="myScrollspy">
                                            	<ul className="list-group">														
													<li><NavLink to={`/account/settings`} exact={true}>My Account</NavLink></li>
													<li><NavLink to={`/account/settings/membership`} exact={true}>Membership</NavLink></li>
													<li className='active'><NavLink to={`/account/settings/credits`} exact={true}>Credits</NavLink></li>
													<li><NavLink to={`/account/settings/payment-methods`} exact={true}>Payment Methods</NavLink></li>
													<li><NavLink to={`/account/settings/billing-history`} exact={true}>Billing History</NavLink></li>
                                            	</ul>
                                            </nav>
							        	</div>
							        </div>	
							    </div>
								<div className="col-md-9 mt-md-0 mt-4">									
                                    {this.state.showHistory ? 
                                        <div className="creditHistBackBtn">
                                        <button className="btn btn-sm btn-default" onClick={this.creditHistory}>Back</button> 
                                        <CreditHistory hideCredit={this.creditHistory}></CreditHistory>
                                        </div>
                                        :
                                        <div>                    
                                        <div className="header">
                                            <div className="header-body">
                                                <div className="row align-items-center">
                                                    <div className="col">
                                                        <h1 className="header-title">
                                                            Credits
                                                        </h1>
                                                    
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card">
                                            <div className="table-responsive">
                                                { this.state.loading ? 
												    <LoadingData></LoadingData> 
													: 
                                                    <div className="credit-container">
                                                        <h4><b>Available Credits</b></h4>
                                                        <p className="mt-2">{this.state.curCredit}</p>
                                                        <div className="d-flex align-items-center flex-md-row flex-column mt-4">
                                                            <button className="btn btn-primary" onClick={this.toggleCreate}>Add More Credits</button>
                                                            <button onClick={this.creditHistory} className="btn btn-default ml-md-3 mt-md-0 mt-3">View Credits History</button>
                                                        </div>
                                                        {this.state.createM === true ? (
                                                            <CreditModal 
                                                                hideCreate={this.toggleCreate}  
                                                                listData = {this.state.creditList}  
                                                                curCredit = {this.state.curCredit}    
                                                                setCredits = {this.setCredit}                       
                                                            ></CreditModal>
                                                        ) : null} 
                                                        <hr className="mt-5 mb-5"/>
                                                        <h4><b>Membership Credits</b></h4>
                                                        <p className="mt-2">{this.context.state.user.plan_id == '1' ? '0' : '5' } per month</p>
                                                        <p className="mt-2">Any unused credits at the end of your billing cycle will roll over to the next month (up to 80)</p>
                                                        {/* <a href="https://support.prowriter.co/kb/guide/en/using-credits-bg9HVmb9J6/Steps/87735" target="_blank" className="mt-2 d-block">Learn more</a> */}
                                                    </div>
                                                }
                                            </div>
                                        </div>
										</div>
                                    }
								</div>
							</div>
						</div>
					</section>
				</div>
            </Fragment>
        );
    }
}
Credits.contextType = AppContext;
export default Credits;



// WEBPACK FOOTER //
// ./src/components/writer/credits/Credits.js